import React from 'react';
import './Footer.css';
import Logo from './Logo';

function Footer() {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <Logo height={60} variant="light" />
            </div>
            <p className="footer-description">
              Software de gestión para empresas de servicio técnico.
              Organiza, optimiza y crece tu negocio.
            </p>
          </div>
          <div className="footer-section">
            <h4>Navegación</h4>
            <ul>
              <li><a onClick={() => scrollToSection('home')}>Inicio</a></li>
              <li><a onClick={() => scrollToSection('features')}>Características</a></li>
              <li><a onClick={() => scrollToSection('pricing')}>Precios</a></li>
              <li><a onClick={() => scrollToSection('testimonials')}>Testimonios</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Contacto</h4>
            <ul>
              <li>📱 +51 964 206 288</li>
              <li>📧 contacto@kreandosoftware.com</li>
              <li>📍 Lima, Perú</li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Síguenos</h4>
            <div className="social-links">
              <a href="#" className="social-link">Facebook</a>
              <a href="#" className="social-link">LinkedIn</a>
              <a href="#" className="social-link">Instagram</a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 KREANDO Software. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
